import React from 'react';
import Layout from '../components/site/Layout';
import { PageHero, CtaBanner } from '../components/site/PageParts';
import useLang from '../i18n/useLang';
import { DatabaseIcon, PlcIcon, ModelIcon, CompassIcon, ErpIcon, AppIcon } from '../components/home/icons';

const services = [
  { id: 'manufacturing', key: 'GrovvMES', icon: DatabaseIcon, tone: 'bg-mint-50', tags: ['SAP Digital Manufacturing', 'SAP ME', 'SAP MII'] },
  { id: 'integration', key: 'SystemIntegration', icon: PlcIcon, tone: 'bg-sky-50', tags: ['OPC', 'RFC', 'OData', 'REST', 'SQL'] },
  { id: 'specification', key: 'Specification', icon: ModelIcon, tone: 'bg-fog-50', tags: ['SAP CDS', 'OData'] },
  { id: 'consulting', key: 'Consultant', icon: CompassIcon, tone: 'bg-sky-50', tags: ['Cloud', 'IoT'] },
  { id: 'project-management', key: 'ProjectManagement', icon: ErpIcon, tone: 'bg-fog-50', tags: [] },
  { id: 'devops', key: 'DevOps', icon: AppIcon, tone: 'bg-mint-50', tags: ['CI/CD'] },
];

export default function Services() {
  const { t } = useLang();
  const header = (key) => t(`Services.${key}.${key}_header`);
  const body = (key) => t(`Services.${key}.${key}_paragraph`);

  return (
    <Layout title={t('header.Services')}>
      <PageHero title={t('pages.services.title')} lead={t('pages.services.lead')} />

      <div className="wrap grid grid-cols-1 gap-12 py-20 sm:py-24 lg:grid-cols-[16rem_minmax(0,1fr)] lg:gap-16">
        <nav aria-label={t('header.Services')} className="hidden lg:block">
          <ul className="sticky top-28 space-y-1 border-s border-fog-200">
            {services.map((s) => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  className="-ms-px block border-s-2 border-transparent py-2 ps-5 text-[0.95rem] text-ink-500 transition-colors hover:border-grovv hover:text-ink"
                >
                  {header(s.key)}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="space-y-5">
          {services.map((s) => (
            <section
              key={s.id}
              id={s.id}
              aria-labelledby={`${s.id}-title`}
              className={`scroll-mt-28 rounded-4xl ${s.tone} p-7 sm:p-10`}
            >
              <div className="flex flex-wrap items-center gap-4">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white text-ink shadow-card ring-1 ring-fog-200">
                  <s.icon className="h-6 w-6" />
                </span>
                <h2 id={`${s.id}-title`} className="heading text-2xl text-ink sm:text-[2rem]">
                  {header(s.key)}
                </h2>
              </div>
              <p className="mt-6 max-w-[68ch] text-[1.08rem] leading-[1.75] text-ink-600">{body(s.key)}</p>
              {s.tags.length > 0 && (
                <ul className="mt-7 flex flex-wrap gap-2">
                  {s.tags.map((tag) => (
                    <li key={tag} dir="ltr" className="rounded-full bg-white px-3 py-1 text-sm font-medium text-ink ring-1 ring-fog-200">
                      {tag}
                    </li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>

      <CtaBanner />
    </Layout>
  );
}
